class ProfilePageController {

  constructor(AlertService, AuthorisationService, LoaderService) {
    this.AlertService = AlertService;
    this.AuthorisationService = AuthorisationService;
    this.LoaderService = LoaderService;
  }

  save() {
    var self = this;

    self.validation = {};
    if(self.password === '' || self.password === undefined){
      self.AlertService.error("The form has validation errors");
      self.validation.password = "You must enter a new password";
      return;
    }
    if(self.password !== self.confirm){
      self.AlertService.error("The form has validation errors");
      self.validation.password = "Your passwords do not match";
      return;
    }

    self.LoaderService.start();
    self.AuthorisationService.updatePassword(self.password)
        .then( () => self.AlertService.success("Password has been updated.") )
        .catch( () => self.AlertService.error("There was a problem updating your password.") )
        .finally( () => self.LoaderService.stop() );
  }
}
ProfilePageController.$inject = ['AlertService', 'AuthorisationService', 'LoaderService'];
export default ProfilePageController;
